import { Component, OnDestroy, OnInit } from "@angular/core";
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
const { version: appVersion } = require('../../../../package.json');
import { environment } from '../../../environments/environment';
import { ConfirmationService } from "primeng/api";
import { Subscription } from "rxjs";
import { AppInjector } from "src/app/app-injector.service";
import { AuthService } from "src/app/auth/services/auth.service";
import { GlobalMessageService } from "src/app/auth/services/global-message.service";
import { AppBreadcrumbService } from "src/app/core/containers/app-main-page/app.breadcrumb.service";
import { UserModel } from "../models/user-model";
import { CatalogService } from "../services/catalog.service";
import { ComplaintService } from '../services/complaint.service';
import { LocalStorageService } from 'ngx-webstorage';
import { Router } from "@angular/router";

@Component({
    template: ''
})
export abstract class BaseComponent implements OnInit, OnDestroy {
    protected router: Router;
    authService: AuthService;
    catalogService: CatalogService;
    complaintService:ComplaintService;
    storageService: LocalStorageService;
    messageService: GlobalMessageService;
    confirmationService: ConfirmationService;
    breadcrumbService: AppBreadcrumbService;
    subscription: Subscription;
    user: UserModel;
    loading = false;
    isLazyLoading = false;
    private _loadingCounter = 0;
    private _lazyLoadingCounter = 0;
    params: any;
    version: any;
    env = environment;

    protected constructor() {
        this.authService = AppInjector.injector.get(AuthService) as AuthService;
        this.catalogService = AppInjector.injector.get(CatalogService) as CatalogService;
        this.complaintService = AppInjector.injector.get(ComplaintService) as ComplaintService;
        this.storageService = AppInjector.injector.get(LocalStorageService);
        this.messageService = AppInjector.injector.get(GlobalMessageService) as GlobalMessageService;
        this.breadcrumbService = AppInjector.injector.get(AppBreadcrumbService) as AppBreadcrumbService;
        this.router = AppInjector.injector.get(Router);
        this.confirmationService = AppInjector.injector.get(ConfirmationService) as ConfirmationService;
        this.subscription = new Subscription();
        this.user = this.authService.storagedUser;
        this.version = appVersion;
    }

    capitalize(text: string): string {
        text = text.toLowerCase();
        return `${text.charAt(0).toUpperCase()}${text.slice(1, text.length)}`;
    }

    ngOnDestroy(): void {
        if (this.subscription) { this.subscription.unsubscribe() };
    }

    ngOnInit(): void {
        this.subscription = new Subscription();
        this.user = this.authService.storagedUser;
    }

    /**
     * Helper para envolver observables y manejar contadores de loading
     * Evita condiciones de carrera cuando múltiples requests concurrentes afectan la misma bandera.
     */
    protected withLoading<T>(obs: Observable<T>, lazy: boolean = false): Observable<T> {
        if (lazy) {
            this._lazyLoadingCounter++;
            this.isLazyLoading = true;
            return obs.pipe(finalize(() => {
                this._lazyLoadingCounter = Math.max(0, this._lazyLoadingCounter - 1);
                this.isLazyLoading = this._lazyLoadingCounter > 0;
            }));
        } else {
            this._loadingCounter++;
            this.loading = true;
            return obs.pipe(finalize(() => {
                this._loadingCounter = Math.max(0, this._loadingCounter - 1);
                this.loading = this._loadingCounter > 0;
            }));
        }
    }
}
